import Box from '@zenbusiness/zui/Box';
import ZuiLink from '@zenbusiness/zui/Link';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'UserMenu',
  slot: 'MenuItem',
  tag: Box,
  propsAdded: {
    component: 'li',
  },
  propsNeeded: ['divider'],
  styles: ({ divider, theme }) => {
    const borderStyle = `1px solid ${theme.palette.border.main}`;
    return {
      ...(divider === 'top' && { borderTop: borderStyle }),
      ...(divider === 'bottom' && { borderBottom: borderStyle }),
    };
  },
});

export const Link = superstyled({
  name: 'UserMenu',
  slot: 'MenuItemLink',
  tag: ZuiLink,
  propsAdded: {
    color: 'primary',
    underline: 'none',
    size: 'md',
  },
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    paddingBlock: theme.spacing(1.5),
    paddingInline: theme.spacing(2),

    '&:hover, & .active': {
      background: 'rgba(207, 249, 250, 0.4)',
    },
  }),
});
